import { useState, useEffect } from 'react'

const NAMES = [
  'María G.',
  'Ana P.',
  'Laura M.',
  'Sofía R.',
  'Valentina C.',
  'Camila S.',
  'Isabella T.',
  'Daniela L.',
  'Mariana B.',
  'Gabriela H.',
]

const CITIES = [
  'Bogotá',
  'Medellín',
  'Cali',
  'Barranquilla',
  'Bucaramanga',
  'Pereira',
]

export interface NotificationData {
  name: string
  city: string
  timeAgo: string
}

export function usePurchaseNotifications() {
  const [notification, setNotification] = useState<NotificationData | null>(
    null,
  )
  const [isVisible, setIsVisible] = useState(false)

  useEffect(() => {
    // Initial delay
    const initialTimeout = setTimeout(() => {
      triggerNotification()
    }, 5000)

    return () => clearTimeout(initialTimeout)
  }, [])

  const triggerNotification = () => {
    // Generate random data
    const name = NAMES[Math.floor(Math.random() * NAMES.length)]
    const city = CITIES[Math.floor(Math.random() * CITIES.length)]
    const timeAgo = `${Math.floor(Math.random() * 10) + 1} min`

    setNotification({ name, city, timeAgo })
    setIsVisible(true)

    // Hide after 5 seconds
    setTimeout(() => {
      setIsVisible(false)

      // Schedule next notification (random between 25-45s)
      const nextDelay = Math.floor(Math.random() * (45000 - 25000 + 1) + 25000)
      setTimeout(triggerNotification, nextDelay)
    }, 5000)
  }

  const dismiss = () => setIsVisible(false)

  return { notification, isVisible, dismiss }
}
